import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthService } from "./Services/AuthService";
import MainLayout from "./Common/MainLayout";
import { listenForAuthEvents } from "./Utilities/AuthBroadcast";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 6 * 1,
      retry: false,
    },
  },
});

const App = () => {
  const [authEvent, setAuthEvent] = useState<"LOGIN" | "LOGOUT" | null>(null);

  useEffect(() => {
    const unsubscribe = listenForAuthEvents(
      () => setAuthEvent("LOGIN"),
      () => setAuthEvent("LOGOUT")
    );
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (authEvent) {
      window.location.reload();
    }
  }, [authEvent]);

  return (
    <QueryClientProvider client={queryClient}>
      {/* <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" /> */}
      <MainLayout />
    </QueryClientProvider>
  );
};

export default App;
